import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/commonFactory.ts
var commonDropdownFactory = (options, path, isMassUpdate = false) => {
  const dropdownOptions = options.map((sellBy, index) => ({
    label: i18n_config_default.t(`${path}.${sellBy}`),
    value: index + 1
  }));
  if (isMassUpdate) {
    return [
      [
        {
          label: i18n_config_default.t("commonTexts.noChanges"),
          value: -1
        }
      ],
      dropdownOptions
    ];
  }
  return [dropdownOptions];
};

export { commonDropdownFactory };
